import '../../../css/info_components/info_title.css'

function ContactTitle() {
    return (
        <main>
            <div className='info_all_parent'>
                <font className='page_nav_font_active'>
                    Contact Details
                </font>
            </div>
        </main>
    );
}

export default ContactTitle;